type Axis = 'x' | 'y'

const canScroll = (axis: Axis, el: Element): boolean => {
  const overflowStyle =
    window.getComputedStyle(el)[axis === 'x' ? 'overflowX' : 'overflowY']
  return /^(auto|scroll)$/.test(overflowStyle)
}

const isOverflowing = (axis: Axis, el: Element): boolean => {
  return axis == 'x'
    ? el.scrollWidth > el.clientWidth
    : el.scrollHeight > el.clientHeight
}

/**
 * Finds the nearest scrollable ancestor of the reference element.
 *
 * @param axis The scroll axis to check.
 * @param el The reference element.
 * @param checkOverflow Also check if the element is overflowing, i.e. currently scrolls. Defaults to true.
 * @returns The nearest scrollable ancestor element.
 */
export const getScrollableParent = (
  axis: Axis,
  el?: Element | null,
  checkOverflow = true
): HTMLElement => {
  if (!el || !(el instanceof HTMLElement) || el === document.body) {
    return document.body
  }
  if (canScroll(axis, el) && (!checkOverflow || isOverflowing(axis, el))) {
    return el
  }

  return getScrollableParent(axis, el.parentElement, checkOverflow)
}
